import React, { useState } from 'react'

import DeleteIcon from '@mui/icons-material/Delete'
import { IconButton } from '@mui/material'
import { useAgencyAccountUnlink } from 'features/agencies/hooks/useAgencyAccountUnlink'

import { ConfirmModal } from 'components/_base'

type AgencyAccountActionsProps = {
  subAccountId: number
}

const AgencyAccountActions = ({ subAccountId }: AgencyAccountActionsProps) => {
  const [openModal, setOpenModal] = useState(false)

  const { mutateAsync: unlinkAccount } = useAgencyAccountUnlink()

  const handleUnlink = async () => {
    await unlinkAccount(subAccountId)
    setOpenModal(false)
  }

  return (
    <div>
      <IconButton aria-label="Unlink subaccount" onClick={() => setOpenModal(true)} size="large">
        <DeleteIcon />
      </IconButton>
      <ConfirmModal
        onClose={() => setOpenModal(false)}
        onConfirm={handleUnlink}
        open={openModal}
        title="Do you want to unlink subaccount?"
      />
    </div>
  )
}

export default AgencyAccountActions
